/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — it's completely free, works in your browser, and needs no signup or download.`)
};

const es_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — es completamente gratis, funciona en tu navegador y no necesita registro ni descarga.`)
};

const de_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — er ist komplett kostenlos, läuft direkt im Browser und benötigt weder Anmeldung noch Download.`)
};

const nl_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — hij is helemaal gratis, werkt in je browser en vereist geen aanmelding of download.`)
};

const fr_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — il est entièrement gratuit, fonctionne dans votre navigateur et ne nécessite ni inscription ni téléchargement.`)
};

const it_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — è completamente gratuito, funziona nel browser e non richiede registrazione né download.`)
};

const pt_br2_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — é totalmente grátis, funciona no seu navegador e não exige cadastro nem download.`)
};

const pt_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — é totalmente gratuito, funciona no seu navegador e não precisa de registo nem de transferência.`)
};

const ja_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、完全無料でブラウザ上で動作し、登録もダウンロードも不要です。`)
};

const zh_timer_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的 — 完全免费，可在浏览器中使用，无需注册或下载。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq1_a", locale)
	if (locale === "en") return en_timer_hub_faq1_a(inputs)
	if (locale === "es") return es_timer_hub_faq1_a(inputs)
	if (locale === "de") return de_timer_hub_faq1_a(inputs)
	if (locale === "nl") return nl_timer_hub_faq1_a(inputs)
	if (locale === "fr") return fr_timer_hub_faq1_a(inputs)
	if (locale === "it") return it_timer_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq1_a(inputs)
	if (locale === "pt") return pt_timer_hub_faq1_a(inputs)
	if (locale === "ja") return ja_timer_hub_faq1_a(inputs)
	return zh_timer_hub_faq1_a(inputs)
};